"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  methods: {
    _openCustom: function _openCustom() {
      var _this = this;
      var initStore = this.initStore,
        customStore = this.customStore,
        collectColumn = this.collectColumn;
      customStore.visible = true;
      initStore.custom = true;
      this.customColumnList = collectColumn.slice(0);
      this.checkCustomStatus();
      this.calcMaxHeight();
      return this.$nextTick().then(function () {
        return _this.calcMaxHeight();
      });
    },
    _closeCustom: function _closeCustom() {
      var customStore = this.customStore,
        customOpts = this.customOpts;
      if (customStore.visible) {
        customStore.visible = false;
        if (!customOpts.immediate) {
          this.handleCustom();
        }
      }
      return this.$nextTick();
    },
    calcMaxHeight: function calcMaxHeight() {
      var $refs = this.$refs,
        customStore = this.customStore;
      var customWrapperElem = $refs.customWrapper ? $refs.customWrapper.$el : null;
      var headElem = $refs.tableHeader ? $refs.tableHeader.$el : null;
      var bodyElem = $refs.tableBody ? $refs.tableBody.$el : null;
      // 判断面板不能大于表格高度
      var tableHeight = 0;
      if (headElem) {
        tableHeight += headElem.clientHeight;
      }
      if (bodyElem) {
        tableHeight += bodyElem.clientHeight;
      }
      customStore.maxHeight = Math.max(0, customWrapperElem ? Math.min(customWrapperElem.clientHeight, tableHeight - 80) : 0);
    },
    checkCustomStatus: function checkCustomStatus() {
      var customStore = this.customStore,
        collectColumn = this.collectColumn,
        customOpts = this.customOpts;
      var checkMethod = customOpts.checkMethod;
      customStore.isAll = collectColumn.every(function (column) {
        return (checkMethod ? !checkMethod({
          column: column
        }) : false) || column.visible;
      });
      customStore.isIndeterminate = !customStore.isAll && collectColumn.some(function (column) {
        return (!checkMethod || checkMethod({
          column: column
        })) && (column.visible || column.halfVisible);
      });
    },
    emitCustomEvent: function emitCustomEvent(type, evnt) {
      var comp = this.$xegrid || this;
      comp.$emit('custom', {
        type: type,
        $table: this,
        $grid: this.$xegrid,
        $event: evnt
      });
    },
    triggerCustomEvent: function triggerCustomEvent(evnt) {
      var customStore = this.customStore;
      if (customStore.visible) {
        this.closeCustom();
        this.emitCustomEvent('close', evnt);
      } else {
        customStore.btnEl = evnt.target;
        this.openCustom();
        this.emitCustomEvent('open', evnt);
      }
    },
    customOpenEvent: function customOpenEvent(evnt) {
      var customStore = this.customStore;
      if (!customStore.visible) {
        customStore.activeBtn = true;
        customStore.btnEl = evnt.target;
        this.openCustom();
        this.emitCustomEvent('open', evnt);
      }
    },
    customColseEvent: function customColseEvent(evnt) {
      var customStore = this.customStore;
      if (customStore.visible) {
        customStore.activeBtn = false;
        this.closeCustom();
        this.emitCustomEvent('close', evnt);
      }
    }
  }
};